// extracted by css-extract-rspack-plugin
var _1 = "a6";
var _2 = "ay";
var _3 = "az";
var _4 = "a0";
var _5 = "a1";
var _6 = "a2";
var _7 = "a3";
var _8 = "ai";
var _9 = "a4";
var _a = "aw";
var _b = "a5";
var _c = "a7";
var _d = "as";
var _e = "ax";
var _f = "av";
var _10 = "au";
var _11 = "at";
export { _1 as "boldFont", _2 as "containerMargins", _3 as "h1Font", _4 as "h2Font", _5 as "h3Font", _6 as "h4Font", _7 as "h5Font", _8 as "hasError", _9 as "primaryText", _a as "required", _b as "secondText", _c as "setSectionColOne", _d as "standardContainer", _e as "standardContainerV2", _f as "standardSubTitle", _10 as "standardTitle", _11 as "standardTitleTop" }
